import { useEffect, useState } from "react";
import { Button, Col, Form, Spin, Tabs } from "antd";
import { useParams } from "react-router-dom";
import "../jobBillingList.scss";
import Client from "redux/models/client";
import K from "utilities/constants";
import moment from "moment";
import { useSelector } from "react-redux";
import VBDRuleDetail from "../tierDiscount/vbdRule";
import { DataTableLayout } from "../../../../../common/components/dataTableLayout/dataTableLayout";
import { ClientSideDataGrid } from "../../../../../common/components/clientSideDataGrid/clientSideDataGrid";
import { selectUserId } from "../../../../../redux/slices/userSlice";
import { Columns } from "./columns";
import { usePageFilter } from "../../../../../hooks/usePageFilters";
import { useQueryState } from "../../../../../hooks/useQueryState";

const TabsConfig = {
  Tiers: { key: "Tiers", label: "Tiers" },
  VBD: { key: "VBD", label: "Discounts" },
};

export default function JobBillingList({ setCurrentPage, tierId }) {
  const userId = useSelector(selectUserId);
  const { id } = useParams();
  const [rowData, setRowData] = useState(null);
  const [vbdEdit, setVbdEdit] = useState(true);
  const [vbdForm] = Form.useForm();

  const [tab, setTab] = useQueryState("billingRuleTab", TabsConfig.Tiers.key);
  const activeTab = TabsConfig[tab];

  const [search, setSearch] = usePageFilter(
    `client_${id}_job_billing_rules_search`,
  );

  useEffect(() => {
    (async () => {
      try {
        const res = await Client.getJobBillingRules(id);
        const change = res.map((item) => {
          return {
            id: item.id,
            name: item.name,
            titleAssociated: item.jobTierTitle.map((obj) => obj.jobTitle.name),
          };
        });

        setRowData(change);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  const addNewHandler = () => {
    setCurrentPage(1);
  };

  const onRowClicked = (params) => {
    tierId.current = params.data.id;
    setCurrentPage(2);
  };

  return (
    <>
      <Tabs
        activeKey={activeTab.key}
        onChange={setTab}
        className="billing-rule-tab"
        items={Object.values(TabsConfig)}
      />
      {activeTab.key === TabsConfig.Tiers.key && (
        <DataTableLayout
          searchDefaultValue={search}
          onSearchChange={setSearch}
          actions={[
            {
              permissions: [
                K.Permissions.EditJobBillingRule,
              ],
              renderer: () => (
                <Col>
                  <Button type="primary" onClick={addNewHandler}>
                    Add New
                  </Button>
                </Col>
              ),
            },
          ]}
        >
          <ClientSideDataGrid
            userId={userId}
            rowData={rowData}
            configKey={K.AgGridTable.Keys.ClientJobBillingRulesVisibleColumn}
            defaultColumnConfig={Columns}
            onRowClicked={onRowClicked}
            rowStyle={{ cursor: "pointer" }}
            quickFilterText={search}
          />
        </DataTableLayout>
      )}
      {activeTab.key === TabsConfig.VBD.key && (
        <VBDRuleDetail
          key={moment().unix()}
          vbdEdit={vbdEdit}
          setVbdEdit={setVbdEdit}
          form={vbdForm}
          tierListing={rowData}
        />
      )}
    </>
  );
}
